import React, { useEffect } from "react";
import './DataDisplayPanel.css';
import './ColorFills.css';
import { ActivityPanel } from "./ActivityPanel";
import { AboutPanel } from "./AboutPanel";
import { ChartDisplay, ChartDisplayProps } from "./ChartDisplay";
import { GetClasses } from "./CSSPicker";
import { Carousel } from "../widgets/Carousel";
import { StateManagerContext } from "../widgets/StateManagerContext";


const s3URL =
    "https://popcorn-images-prod.s3.us-west-2.amazonaws.com/party/datadisplay/";

export type DataDisplayPanelProps = {
    width: number;
    height: number;
    idPrefix: string;
    region? : string;
}


const CalculatePanelPositions = (index: number, n: number, width: number, array: number[]) => {
    if (array.length > 0) {
        array.splice(0);
    }

    const half = Math.round(n / 2 - 0.1);

    for (let i = 0; i < n; i++) {
        if (i < index) {
            if (i < (index - half)) {
                const x = (n - index + i) * width;
                array.push(x);
            }
            else {
                const x = (i - index) * width;
                array.push(x);
            }
        }
        else if (i === index)
            array.push(0);
        else {
            if (i > (index + half)) {
                const x = (i - n - index) * width;
                array.push(x);
            }
            else {
                const x = (i - index) * width;
                array.push(x);
            }
        }
    }
}

export const DataDisplayPanel = ({ width, height, idPrefix, region }: DataDisplayPanelProps): React.JSX.Element => {

    const stateManager = React.useContext(StateManagerContext);
    const mapData = stateManager.weeklyActivity();

    const currentIndex = React.useRef<number>(0);
    const currentPanels = React.useRef<HTMLDivElement[]>([]);
    const regionName = React.useRef<string>("US");

    if(region !== undefined)
        regionName.current = region;

    const positions = new Array<number>();
    CalculatePanelPositions(currentIndex.current, 7, width, positions);


    const engagement = regionName.current === 'US' ? mapData.nationalStats : (() => {
        for (let i = 0; i < mapData.items.length; i++) {
            if (mapData.items[i].geo.id === regionName.current)
                return mapData.items[i].stats;
        }
        return mapData.items[0].stats;
    })();

    const aboutCharts = regionName.current === 'US' ? mapData.nationalAbout : (() => {
        for (let i = 0; i < mapData.items.length; i++) {
            if (mapData.items[i].geo.id === regionName.current)
                return mapData.items[i].about;
        }
        return mapData.items[0].about;
    })();

    const dataCharts = regionName.current === 'US' ? mapData.nationalCharts : (()=>{
        for (let i = 0; i < mapData.items.length; i++) {
            if (mapData.items[i].geo.id === regionName.current)
                return mapData.items[i].charts;
        }
        return mapData.items[0].charts;
    })();

    const bottomSpaces = [0,0,150,90,150,70,150];

    const panels = new Array<JSX.Element>();
    panels.push(<ActivityPanel engagement={engagement} width={width - 100} height={height} regionName={regionName.current} idPrefix={idPrefix + "_ActivityPanel_"} />);
    panels.push(<AboutPanel charts={aboutCharts} width={width - 100} height={height} regionName={regionName.current} idPrefix={idPrefix + "_ActivityPanel_"} valuePostfixes={['', '', '']} />);
    for(let i = 0; i < dataCharts.length; i++)
    {
        const chartProps: ChartDisplayProps = {
            chartData: dataCharts[i],
            x: 0,
            y: 0,
            width: width - 100,
            height: height,
            options: {
                showAxis: false,
                barCSS: GetClasses(4,'hover'),
                barHighlightCSS: GetClasses(3,'Highlight'),
                axisColor: 'black',
                bottomLabelSpace : bottomSpaces[i+2],
                yCalculator : 'variation',
                yCalcParameter : 2,
                valuePostfix: '%',
                textHeight: 14,
                xmin: 0,
                xmax: 0,
                isDate: false,
                idPrefix: idPrefix + "PanelChart" + i,
                barWidth : 0.5,
            }
        }
        panels.push(
            <svg id={idPrefix + "SVG_Panel" + i} width={width - 100} height={height}>
                <ChartDisplay {...chartProps} />
            </svg>
        );
    }

    return <Carousel width={width} height={height} scrollButtonWidth={50} idPrefix='DataDisplayPanel' panels={panels} display={1} userControlled={true}/>

}

/*

    useEffect(() => {
        const arr = new Array<HTMLDivElement>()
        for (let i = 0; i < 7; i++) {
            const element = document.getElementById(idPrefix + "Panel" + i);
            arr.push((element as HTMLDivElement))
        }
        currentPanels.current = arr;
    });

    const onRightClick = () => {
        //const prevIndex = currentPanel === 0 ? 4 : currentPanel - 1;
        const nextIndex = currentIndex.current === 6 ? 0 : currentIndex.current + 1;
        CalculatePanelPositions(nextIndex, 7, width, positions)

        for (let i = 0; i < currentPanels.current.length; i++) {
            if (i == currentIndex.current) {
                currentPanels.current[i].className = "transitionOn";
            }
            else if (i == nextIndex) {
                currentPanels.current[i].className = "transitionOn";
            }
            else {
                currentPanels.current[i].className = "transitionOff";

            }
            currentPanels.current[i].style.left = positions[i] + "px";
        }

        currentIndex.current = nextIndex;
    }

    const onLeftClick = () => {
        const prevIndex = currentIndex.current === 0 ? 6 : currentIndex.current - 1;

        CalculatePanelPositions(prevIndex, 7, width, positions)

        for (let i = 0; i < currentPanels.current.length; i++) {
            if (i == currentIndex.current) {
                currentPanels.current[i].className = "transitionOn";
            }
            else if (i == prevIndex) {
                currentPanels.current[i].className = "transitionOn";
            }
            else {
                currentPanels.current[i].className = "transitionOff";

            }
            currentPanels.current[i].style.left = positions[i] + "px";
        }

        currentIndex.current = prevIndex;

    }





    return (
        <div style={{ height: height + "px", width : width + "px", backgroundColor: "black", display: "flex", flexDirection: "row" , borderRadius : "25px",  overflow : "clip"}} id={idPrefix}>
            <div id={idPrefix + "LeftButton"} style={{ width: "50px", height: height + "px", zIndex : 1}} className="carouselButtonPanel" 
                onClick={() => { onLeftClick(); }}>
                    <img src={s3URL + "leftCarouselButton.png"} style={{width : "30px", maxWidth : "30px", height : "30px", maxHeight : "30px",  marginTop : (0.5 * height - 15) + "px", marginLeft : "10px",  opacity : 0.7}} />
                </div>
            <div id={idPrefix + "MainPanel"}
                style={{ width: (width - 100) + "px", height: height + "px", backgroundColor: "black", position: "relative", overflow: "visible" }}>
                {
                    positions.map((left: number, index: number) => {
                        return <div id={idPrefix + "Panel" + index} className="transitionOff"
                            style={{ width: (width - 100) + "px", height: height + "px", backgroundColor: "black", top: "0px", left: left + "px" }}>
                            {
                                (() => {
                                    if (index === 0) {
                                        return <ActivityPanel engagement={engagement} width={width - 100} height={height} regionName={regionName.current} idPrefix={idPrefix + "_ActivityPanel_"} />
                                    }
                                    else if (index === 1) {
                                        return <AboutPanel charts={aboutCharts} width={width - 100} height={height} regionName={regionName.current} idPrefix={idPrefix + "_ActivityPanel_"} valuePostfixes={['', '', '']} />
                                    }
                                    else {
                                        const chartProps: ChartDisplayProps = {
                                            chartData: dataCharts[index-2],
                                            x: 0,
                                            y: 0,
                                            width: width - 100,
                                            height: height,
                                            options: {
                                                showAxis: false,
                                                barCSS: GetClasses(4,'hover'),
                                                barHighlightCSS: GetClasses(3,'Highlight'),
                                                axisColor: 'black',
                                                bottomLabelSpace : bottomSpaces[index],
                                                yCalculator : 'variation',
                                                yCalcParameter : 2,
                                                valuePostfix: '%',
                                                textHeight: 14,
                                                xmin: 0,
                                                xmax: 0,
                                                isDate: false,
                                                idPrefix: idPrefix + "PanelChart" + index,
                                                barWidth : 0.5,
                                            }
                                        }
                                        return (
                                            <svg id={idPrefix + "SVG_Panel" + index} width={width - 100} height={height}>
                                                <ChartDisplay {...chartProps} />
                                            </svg>
                                        );
                                    }
                                })()
                            }
                        </div>
                    })}

            </div>
            <div id={idPrefix + "RightButton"} style={{ width: "50px", height: height + "px", zIndex : 1}} className="carouselButtonPanel"
                onClick={() => { onRightClick(); }}>
                    <img src={s3URL + "rightCarouselButton.png"} style={{width : "30px", maxWidth : "30px", height : "30px", maxHeight : "30px",  marginTop : (0.5 * height - 15) + "px", marginLeft : "10px", opacity : 0.7}}/>
                </div>


        </div>
    );

}*/

